import { mergeStyles } from '@bulknutrients/bulk-shared-lib/utils';
import type { ReactElement } from 'react';
import { twJoin } from 'tailwind-merge';

export function HorizontalDivider({
  className,
}: {
  className?: string;
}): ReactElement {
  return (
    <div
      className={twJoin(
        'hr',
        mergeStyles(
          className ?? '',
          'mx-0 my-10 h-px min-h-px w-auto bg-grey/50'
        )
      )}
    />
  );
}
